var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.96 0 0 0.24 250 178.12)",
    id: "f2di3jMQn_VNqol7sQX_q"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(6,131,58)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(120,121,118)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -93.64821 -23.33009 C -93.64821 -62.16571 -89.7243 -93.64820999999999 -84.88392 -93.64820999999999 L 83.97911 -93.64820999999999 L 83.97911 -93.64820999999999 C 89.31921 -93.64820999999999 93.64821 -58.915499999999994 93.64821 -16.070539999999994 L 93.64821 34.21941 L 93.64821 34.21941 C 93.64821 67.04103 90.33195 93.6482 86.24114 93.6482 L -85.78872999999999 93.6482 L -85.78872999999999 93.6482 C -90.12939999999999 93.6482 -93.64819999999999 65.41592 -93.64819999999999 30.58963 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.96 0 0 0.24 250 248.74)",
    id: "qeZx5FcPokQYNab_-ae5_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(6,131,58)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(120,121,118)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -93.64821 -20.61248 C -93.64821 -60.949 -89.7243 -93.64821 -84.88392 -93.64821 L 83.97911 -93.64821 L 83.97911 -93.64821 C 89.31921 -93.64821 93.64821 -57.57318000000001 93.64821 -13.072370000000006 L 93.64821 31.922639999999994 L 93.64821 31.922639999999994 C 93.64821 66.01272 90.33195 93.6482 86.24114 93.6482 L -85.78872999999999 93.6482 L -85.78872999999999 93.6482 C -90.12939999999999 93.6482 -93.64819999999999 64.32481 -93.64819999999999 28.152590000000004 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.96 0 0 0.24 250 322.74)",
    id: "INmI3LpPQfa3OBDMC-WOp"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(6,131,58)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(120,121,118)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M -93.64821 -20.61248 C -93.64821 -60.949 -89.7243 -93.64821 -84.88392 -93.64821 L 83.97911 -93.64821 L 83.97911 -93.64821 C 89.31921 -93.64821 93.64821 -57.57318000000001 93.64821 -13.072370000000006 L 93.64821 31.922639999999994 L 93.64821 31.922639999999994 C 93.64821 66.01272 90.33195 93.6482 86.24114 93.6482 L -85.78872999999999 93.6482 L -85.78872999999999 93.6482 C -90.12939999999999 93.6482 -93.64819999999999 64.32481 -93.64819999999999 28.152590000000004 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon);
export default __webpack_public_path__ + "static/media/nav-icon.4b4ebb2c56588851c024b8369538540d.svg";
export { ForwardRef as ReactComponent };